<template>
  <v-flex
    ref="toc"
    v-view="handleScroll"
    class="toc"
  >
    <a
      class="link_iconed"
      @click="saveData()"
    >
      <v-icon>keyboard_arrow_left</v-icon> {{ $t('sheet.cancel_button') }}</a>
    <a
      v-if="$vuetify.breakpoint.xsOnly"
      class="close-btn"
      @click="closeDialog"
    >
      <v-icon>clear</v-icon>
    </a>
    <template v-if="items">
      <ul
        v-for="(elements, index) in items"
        :key="index"
        class="mb-3"
      >
        <li
          v-for="(item, index) in elements"
          :key="index"
          class="mb-1"
        >
          <div
            v-if="item && item.header"
            :class="{ 'sz_medium_grey--text': !isCurrentList(elements) }"
            class="d-inline-block"
          >
            <v-btn
              v-if="showNumbers"
              class="button-height"
              fab
              dark
              color="sz_red"
              :class="{ 'active sz_medium_grey--text': !isCurrentList(elements) }"
            >
              <span>{{ item.number }}</span>
            </v-btn>
            <span>
              {{ item.header }}
            </span>
            <p
              v-if="headerCommentMark && headerCommentMark[item.number] && isCurrentEdition"
              class="ml-2 my-2 pa-0 px-1 font-weight-regular"
            >
              <v-icon :color="$vuetify.theme.sz_red">
                notifications
              </v-icon>
              {{ $t('family_card.document_section.audit_comment') }}
            </p>
          </div>
          <a
            v-else-if="
              item && isCurrentList(elements) && !getHiddenSelectors.includes(item.selector)
            "
            :class="{ active: getCurrentSelectorName === item.selector }"
            @click="goToById(item.selector)"
          >{{ item.name }}</a>
        </li>
      </ul>
    </template>
  </v-flex>
</template>

<script>
export default {
    name: 'SheetTableOfContents',
    props: {
        showNumbers: {
            default: true
        },
        headerCommentMark: {
            default: null
        }
    },
    data () {
        return {
            scrollOptions: { duration: 300, offset: 18, easing: 'easeInOutCubic' },
            fixedToCPosition: 0
        };
    },
    computed: {
        getCurrentSelectorName () {
            return this.$store.getters['sheet/getCurrentSelectorName'];
        },
        items () {
            return this.$store.getters['sheet/getTableOfContentsList'];
        },
        currentRouteName () {
            return this.$route.name;
        },
        getHiddenSelectors () {
            return this.$store.getters['sheet/getHiddenSelectorsList'];
        },
        familyId () {
            return this.$route.params.familyId;
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        }
    },
    mounted () {
        this.fixedToCPosition = this.$refs.toc.offsetTop - 15;
    },
    methods: {
        goToById (id) {
            this.$vuetify.goTo('#' + id, this.scrollOptions);
            if (this.$vuetify.breakpoint.xsOnly) {
                this.closeDialog();
            }
        },
        handleScroll (e) {
            if (window.pageYOffset >= this.fixedToCPosition) {
                e.target.element.classList.add('stick-to-top');
            } else {
                e.target.element.classList.remove('stick-to-top');
            }
        },
        isCurrentList (element) {
            const _item = element.find((el) => {
                return el && el.header;
            });
            return _item.name === this.currentRouteName;
        },
        closeDialog () {
            this.$emit('closeDialog');
        },
        saveData () {
            this.$router.push({ name: 'family-card', params: { id: this.familyId } });
        }
    }
};
</script>

<style lang="scss">
@import './../../../assets/css/_variables';
.toc {
  position: relative;
  .close-btn {
    position: absolute;
    right: 15px;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  span {
    font-size: 16px;
    font-weight: bold;
  }
  li {
    a {
      color: $sz_violet;
      font-size: 14px;
      font-weight: normal;
      margin-left: 20px;
      &.active {
        font-weight: bold;
      }
    }
    p {
      color: $sz_grafit;
      font-weight: 600;
      font-size: 14px;
      margin-bottom: 5px;
    }
  }
  .v-btn--floating:not(.v-btn--depressed):not(.v-btn--flat) {
    box-shadow: 0 5px 8px 2px rgba(237, 28, 36, 0.12);
    &.active {
      box-shadow: 0 0 8px 2px rgba(220, 214, 214, 0.38);
      background: #ffffff !important;
    }
  }
  .button-height {
    height: 30px;
    width: 30px;
  }
}
.stick-to-top {
  top: 15px;
  position: fixed;
  width: 20%;
}
</style>
